import { Box, Divider, MenuItem, MenuList, Typography } from "@mui/material";
import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import MenuPopover from "src/shared_components/menu/MenuPopover";
import { useAuth } from "src/auth/AuthContext";
import { logout } from "src/redux/slices/authSlice";

interface AccountPopoverProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  open: boolean;
  username: string | undefined;
}

export const AccountPopover: React.FC<AccountPopoverProps> = (props) => {
  const { anchorEl, onClose, open, username } = props;

  const auth = useAuth();
  const dispatch = useDispatch();

  const handleSignOut = useCallback(() => {
    onClose?.();
    dispatch(logout());
  }, [onClose, auth]);

  return (
    <MenuPopover
      anchorEl={anchorEl}
      arrow="top-right"
      onClose={onClose}
      open={open}
    >
      <Box
        sx={{
          py: 1.5,
          px: 2,
        }}
      >
        <Typography variant="overline">Account</Typography>
        <Typography color="text.secondary" variant="body2">
          {username}
        </Typography>
      </Box>
      <Divider />
      <MenuList
        disablePadding
        dense
        sx={{
          p: "8px",
          "& > *": {
            borderRadius: 1,
          },
        }}
      >
        <MenuItem onClick={handleSignOut}>Sign out</MenuItem>
      </MenuList>
    </MenuPopover>
  );
};
